<template>
  <!-- Main wrapper  -->
  <div id="main-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-main">{{trans('login_2')}}</h3></div>
    </div>
    <div class="unix-login">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-8 col-sm-12">
            <div class="login-content card">
              <div class="login-form">
                <h4>{{trans('login_2')}}</h4>
                <form @submit="login">
                  <div class="form-group">
                    <input type="text" v-model="username" class="form-control" :placeholder="trans('id_card')" autocomplete="off">
                  </div>
                  <div class="form-group">
                    <input type="password" v-model="password" class="form-control"
                           :placeholder="trans('password')" autocomplete="new-password">
                  </div>
                  <div class="checkbox">
                    <label>
                      <input checked type="checkbox"> {{trans('remember_me')}}
                    </label>
                  </div>
                  <div class="error-note">{{error}}</div>
                  <button type="submit" class="btn btn-primary btn-flat m-b-10 m-t-10">{{trans('sign_in')}}</button>
                  <!-- <div class="register-link text-center">
                    <p v-if="false">{{trans('dont_have_account')}}
                      <router-link to="/register">{{trans('sign_up_here')}}</router-link>
                    </p>
                    <p>
                      <router-link to="/ForgotPassword">{{trans('forgot_your_password')}}</router-link>
                    </p>
                  </div> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Wrapper -->
</template>
<script>
  import { localMixin } from '../../mixins/localMixin';

  export default {
    name: 'Login',
    data() {
      return {
        username: null,
        password: null,
        error: null
      };
    },
    mixins: [localMixin],
    methods: {
      login(e) {
        let self = this;
        this.error = null;
        if (!this.username && !this.password) {
          return true;
        }
        e.preventDefault();
        let data = { lIdentify: this.username, lPhone: this.password };
        $.ajax({
          url: this.$parent.api.host + this.$parent.api.login,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(data),
          success: function (response) {
            // debugger;
            if (response.token) {
              self.$parent.user = response;
              self.$parent.saveUser();
              self.$parent.loadUser();
            }
          },
          error: function (error) {
            console.log(error);
          },
          dataType: 'json'
        });
      },
    },
  };
</script>
<style scoped>
  .error-note {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue